import { API_ROUTES } from '@/shared/constants/api.routes';
import {
    IRevokeInviteRequest,
    ISendInviteRequest,
    ISendWorkspaceInviteRequest,
    IUpdateInvitePermissionRequest,
} from '../interface/requests/invite-request';
import { httpClient } from '@/lib/http-client/http-client';
import {
    IInviteDetailResponse,
    IInviteListResponse,
} from '../interface/responses/invite-response';

class InviteService {
    constructor() {}

    async sendInvite(request: ISendInviteRequest) {

        return await httpClient.post(
            API_ROUTES.Specification.invite.root,
            request
        );
    }
    async acceptInvite(hash: string) {
        return await httpClient.patch(
            API_ROUTES.Specification.invite.accept(hash)
        );
    }
    async getInviteDetail(hash: string) {
        return await httpClient.get<IInviteDetailResponse>(
            API_ROUTES.Specification.invite.detail(hash)
        );
    }
    async getInviteList(specificationId: string) {
        return await httpClient.get<IInviteListResponse[]>(
            API_ROUTES.Specification.invite.list(specificationId)
        );
    }

    async updateInvitePermission(
        specificationId: string,
        data: IUpdateInvitePermissionRequest
    ) {
        return await httpClient.patch(
            API_ROUTES.Specification.invite.permission(specificationId),
            data
        );
    }

    async revokeInvite(specificationId: string, data: IRevokeInviteRequest) {
        return await httpClient.patch(
            API_ROUTES.Specification.invite.revoke(specificationId),
            data
        );
    }
    async revokeInviteWidthInviteId(inviteId: string) {
        return await httpClient.patch(
            API_ROUTES.Specification.invite.revokeInviteWidthInviteId,
            {
                inviteId
            }
        );
    }
    async resendInvite(inviteId: string) {
        return await httpClient.post(
            API_ROUTES.Specification.invite.resend,
            { inviteId }
        );
    }
    async sendWorkspaceInvite(request: ISendWorkspaceInviteRequest) {
        return await httpClient.post(
            API_ROUTES.Workspaces.invite,
            request
        );
    }
    async acceptWorkspaceInvite(hash: string) {
        return await httpClient.patch(
            API_ROUTES.Workspaces.inviteAccept(hash)
        );
    }
}

export const inviteService = new InviteService();

export default InviteService;
